import { showMessage } from "../actions";

export const useAlert = () => {
    const showAlert = (messageObject) => {
        showMessage(messageObject)
    }
    return {
        showAlert
    }
}